import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import clearIcon from '../../images/clear-field-icon_b.png';
import editIconActive from '../../images/insight360/edit-icon_active.png';
import InlineEdit from './InlineEdit/InlineEdit';
import { numberWithCommas } from '../../util/CommonUtils';
import * as definitionActions from '../../actions/definitionActions';
import * as salesCatalystActions from '../../actions/salesCatalystActions';
import { DEFINITION_HEADER_LENGTH } from '../../constants';
import Modal from './Modal/Modal';
import SaveDefinitionLabelPopupScreen from "./SaveDefinitionLabelPopupScreen";
import {
  SALES_CATALYST_DEFINITION_LENGTH_WARNING,
} from '../../messages/messages';

const modalSettingStyle = {
  width: '51%',
  height: '40px',
  left: '24%',
  top: '20%',
};
class SalesCatalystInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isInEditMode: false,
      headerLabelUpdateObject: {},
      headerLabelUpdateCallBack: '',
      index: null,
      popupCloseButtonClick: true,
    };
  }

  onModalPopupXButtonClick = () => {
    if (this.state.popupCloseButtonClick) {
      this.state.headerLabelUpdateCallBack(false);
    } else {
      this.setState({
        popupCloseButtonClick: true,
      });
    }
  };

  toggleEditMode = value => {
    this.setState({
      isInEditMode: value,
    });
  };

  validateHeaderLabel = (value, callback) => {
    // check the label max length equal to 64
    const callBackArg = value.length < DEFINITION_HEADER_LENGTH;
    if (callBackArg) {
      callback(true);
    } else {
      callback(false, SALES_CATALYST_DEFINITION_LENGTH_WARNING);
    }
  };

  updateHeaderLabel = (value, callback, index) => {
    const copyOfDataList = _.clone(this.props.dataList);
    const expression = [];
    let definationId = null;
    copyOfDataList.forEach((label, key) => {
      if (key === index) {
        const expressionObj = {
          id: label.expId,
          title: value.trimStart(),
          expression: label.expression,
        };
        expression.push(expressionObj);
        definationId = label.defId;
      }
    });

    const labelUpdateData = {
      defId: definationId,
      defName: '',
      expressions: expression,
    };
    this.setState({
      headerLabelUpdateObject: labelUpdateData,
      headerLabelUpdateCallBack: callback,
      index,
    });

    this.confirmationModal.show();
  };

  onPersonaHeaderLabelSave = definationObject => {
    const mainCategory = _.clone(this.props.field);
    const subCategory = _.clone(this.props.subCategory);
    const category = { mainCategory, subCategory };
    const headerLabelUpdateObject = _.clone(
      this.state.headerLabelUpdateObject,
    );

    if (
      definationObject.definitionFolderId !==
      headerLabelUpdateObject.defId
    ) {
      headerLabelUpdateObject.defId =
        definationObject.definitionFolderId;
      headerLabelUpdateObject.expressions[0].id = null;
    }
    headerLabelUpdateObject.defName =
      definationObject.definitionFolderName;

    this.props.saveUpdatedDefinitionData(
      headerLabelUpdateObject,
      this.state.headerLabelUpdateCallBack,
      this.state.index,
      category,
      this.props.forceLabelUpdate
    );
    this.setState(
      {
        popupCloseButtonClick: false,
      },
      () => {
        // Default Edit Screen
        if (typeof (this.props.toggleEditMode) !== 'undefined') {
          this.props.toggleEditMode('', 0, '', false);
        }
        this.confirmationModal.hide();
      },
    );
  };

  render() {
    const { data, deleteHandler, field, subCategory, index,
      targetLabelClass, backgroundColor, hideEditOption, removeIcon, disableSWInfo,
      editBlockTopMargin, editModeClass,
      renderEditView, toggleEditMode } = this.props;
    return (
      <div
        className={!this.state.isInEditMode ? `${targetLabelClass}` : `${editModeClass !== undefined ? editModeClass : 'target-label-field'}`}
        style={{
          background: (backgroundColor !== 'undefined' && !this.state.isInEditMode) ? backgroundColor : 'transparent',
        }}
      >
        <Modal
          title=""
          ref={node => (this.confirmationModal = node)}
          dialogStyles={modalSettingStyle}
          afterClose={this.onModalPopupXButtonClick}
        >
          <div className="text-center">
            <div className="">
              <SaveDefinitionLabelPopupScreen
                definitionTree={this.props.definitionTree}
                personaHeaderLabelUpdateObject={
                  this.state.headerLabelUpdateObject
                }
                onPersonaHeaderLabelSave={this.onPersonaHeaderLabelSave}
                productNo={this.props.productNo}
              />
            </div>
          </div>
        </Modal>
        {
          data && data.label ?
            <InlineEdit
              textVal={data.label}
              editBlockWidth="100%"
              editBlockTopMargin={editBlockTopMargin !== undefined ? editBlockTopMargin : '1%'}
              icon={editIconActive}
              editFunction={this.toggleEditMode}
              updateFn={this.updateHeaderLabel}
              validateFn={this.validateHeaderLabel}
              defaultViewWidth="95%"
              index={index}
              hideEditOption={hideEditOption}
              renderEditViewOnStart={renderEditView}
              toggleEditModefromParent={toggleEditMode}
            />
            : ''
        }
        {!_.isEmpty(this.props.data) && (!this.state.isInEditMode) && !renderEditView &&
          <div
            className="clear-icon-target-market"
            style={{ marginLeft: (hideEditOption ? '0.5%' : '') }}
            onClick={() => deleteHandler(field, subCategory, index)}
          >
            <img src={removeIcon !== undefined ? removeIcon : clearIcon} alt="clear-icon" />
          </div>}
        {!disableSWInfo && !_.isEmpty(this.props.data) &&
          (!this.state.isInEditMode) && !renderEditView &&
          <div className="sample-weighted-content">
            <div className="bold" style={{ display: 'inline-block' }}>SAMPLE: <span className="red-text">{numberWithCommas(
              Math.round(data.sample || data.intab))}</span>
              <span>|</span>
            </div>
            <div className="bold" style={{ display: 'inline-block' }}>WEIGHTED: <span className="red-text">{numberWithCommas(
              Math.round(data.weighted))}</span></div>
          </div>}
      </div>
    );
  }
}

SalesCatalystInput.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object]),
  deleteHandler: PropTypes.func,
  field: PropTypes.string,
  targetLabelClass: PropTypes.string,
  backgroundColor: PropTypes.string,
  index: PropTypes.number,
  subCategory: PropTypes.string,
  productNo: PropTypes.number,
  saveUpdatedDefinitionData: PropTypes.func,
  definitionTree: PropTypes.arrayOf(PropTypes.object),
  dataList: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object]),
  hideEditOption: PropTypes.bool,
  removeIcon: PropTypes.string,
  disableSWInfo: PropTypes.bool,
  editBlockTopMargin: PropTypes.string,
  editModeClass: PropTypes.string,
  renderEditView: PropTypes.bool,
  toggleEditMode: PropTypes.func,
  forceLabelUpdate: PropTypes.func,
};

SalesCatalystInput.defaultProps = {
  hideEditOption: false,
  renderEditView: false,
};
function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    studySource: typeof state.study.salesCatalystStudy !== 'undefined' &&
    typeof state.study.salesCatalystStudy.ss &&
    state.study.salesCatalystStudy.ss === 'SIMMONS' ? 1 : 2,
    definitionTree:
      typeof state.definition.definitionTree !== 'undefined' &&
        typeof state.definition.definitionTree.data !== 'undefined'
        ? state.definition.definitionTree.data
        : [],
  };
}


const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const refreshDefinationdata = () => {
    dispatch(
      definitionActions.getDefinitionTreeLoad(
        stateProps.loginResponse.data.token,
        stateProps.studySource,
        stateProps.activeAccountId,
        stateProps.productNo,
      ),
    );
  };

  const saveUpdatedDefinitionData = (updatedlabelData, callbackFn, index, category, forceLabelUpdateFn) => {
    dispatch(
      salesCatalystActions.saveDataToDefinitionFolder(
        stateProps.loginResponse.data.token,
        stateProps.loginResponse.data.uid,
        stateProps.activeAccountId,
        stateProps.productNo,
        updatedlabelData,
        callbackFn,
        refreshDefinationdata,
        index,
        category,
        forceLabelUpdateFn,
      ),
    );
  };

  return { ...stateProps, ...ownProps, saveUpdatedDefinitionData, };
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(SalesCatalystInput);
